import { Phone, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const detectUsageMilestoneUpgradeTriggerAr: TemplateAr = {
  name: 'رصد مرحلة الاستخدام + محفّز الترقية',
  description:
    'الذكاء الاصطناعي يرصد وصول العملاء لحدود خططهم أو لمرحلة استخدام مهمة، ويشغّل محادثة الترقية في اللحظة المناسبة.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: Users, label: 'وصل المرحلة' },
    { icon: Sparkles, label: 'الـ AI يشغّل' },
    { icon: Phone, label: 'عرض ترقية', final: true },
  ],
  detailDescription: {
    paragraph1:
      'اعرض الترقية لمّا يوصل العميل حدّ خطته أو مرحلة استخدام مهمة، مو بعد ما يفوت الوقت. الـ AI يراقب استخدام API وعدد المستخدمين واستهلاك التخزين وتبنّي المزايا وسلوك المستخدم المتقدم. وأول ما يثبت العميل أنه يحتاج أكثر، يشغّل عرض ترقية مخصص عبر الإيميل أو رسالة داخل المنتج أو مكالمة هاتفية.',
    paragraph2:
      'تتابع فرص الترقية ونتائج التحويل في تحليلات منتجك أو CRM أو أدوات الإيرادات عندك. والـ AI يجرّب توقيتات وصياغات وخصومات مختلفة عشان يرفع معدل التحويل. والترقية اللي تنجح تشغّل تعديل الفوترة وفتح المزايا تلقائياً.',
  },
  benefits: [
    'تحوّل المستخدم المجاني لمدفوع في وقته الصح',
    'إيراد التوسّع ما يفوتك',
    'كل مستخدم له مسار ترقية على مقاسه',
    'تجرّب صيغ التسعير والرسائل',
    'الاحتكاك في الترقية ينزل',
    'متوسط الإيراد لكل حساب يرتفع',
  ],
};
